<template lang="pug">
.section
  .section-header
    template(v-if="!isDetail && !isMember")
      h1 {{ $t("ui.rescue_fund_summary") }}
    template(v-else)
      template(v-if="isDetail")
        template(v-if="isOperator")
          h1 {{ $t("ui.rescue_fund_summary_daily") }}
        template(v-else)
          .section-header-back
            a.btn.btn-sm.btn-icon(href="javascript:void(0)" @click="redirect()")
              i.fas.fa-arrow-left
          h1 {{ $t("ui.rescue_fund_summary_daily") }}
          .section-header-breadcrumb
            .breadcrumb-item
              a(href="javascript:void(0)" @click="redirect()") {{ $t("ui.rescue_fund_summary") }}
            .breadcrumb-item.active
              span {{ $t('ui.rescue_fund_summary_daily') }}
      template(v-else)
        template(v-if="isOperator")
          .section-header-back
            a.btn.btn-sm.btn-icon(href="javascript:void(0)" @click="redirect1()")
              i.fas.fa-arrow-left
          h1 {{ $t("ui.rescue_fund_member") }}
          .section-header-breadcrumb
            .breadcrumb-item
              a(href="javascript:void(0)" @click="redirect1()") {{ $t('ui.rescue_fund_summary_daily') }}
            .breadcrumb-item.active
              span {{ $t('ui.rescue_fund_member') }}

          //- .section-header-back
          //-   a.btn.btn-sm.btn-icon(href="javascript:void(0)" @click="redirect()")
          //-     i.fas.fa-arrow-left
          //- h1 {{ $t("ui.rescue_fund_summary_daily") }}
          //- .section-header-breadcrumb
          //-   .breadcrumb-item
          //-     a(href="javascript:void(0)" @click="redirect()") {{ $t("ui.rescue_fund_summary") }}
          //-   .breadcrumb-item.active
          //-     span {{ $t('ui.rescue_fund_summary_daily') }}
        template(v-else)
          .section-header-back
            a.btn.btn-sm.btn-icon(href="javascript:void(0)" @click="redirect1()")
              i.fas.fa-arrow-left
          h1 {{ $t("ui.rescue_fund_member") }}
          .section-header-breadcrumb
            .breadcrumb-item
              a(href="javascript:void(0)" @click="redirect()") {{ $t("ui.rescue_fund_summary") }}
            .breadcrumb-item
              a(href="javascript:void(0)" @click="redirect1()") {{ $t('ui.rescue_fund_summary_daily') }}
            .breadcrumb-item.active
              span {{ $t('ui.rescue_fund_member') }}
  .section-body
    .row
      .col-12
        .card.mb-0
          template(v-if="!isDetail && !isMember")
            .card-header
              .row.w-100              
                .form-group.col-md-12.col-lg-6.col-xl-3.col-12.mb-1(v-if="!isOperator")
                  b-input-group(size="sm")
                    b-input-group-text(slot="prepend")
                      i.fa.fa-user
                    DebounceInput(autofocus type="text" v-model="searchID" :placeholder="$t('message.search_by_operator')" @enter="getListSummary(true)" size="sm")
                .form-group.col-md-12.col-lg-6.col-xl-3.col-12.mb-1
                  b-input-group(size="sm")
                    b-input-group-text(slot="prepend")
                      span {{ $t('ui.cycle') }}
                    b-form-select(v-model="rescue_cycle" @change="getListSummary(true)" size="sm")
                      option(value="") {{ $t('ui.all') }}
                      option(value="DAILY") {{ $t('ui.daily') }}
                      option(value="WEEKLY") {{ $t("ui.weekly") }}
                      option(value="MONTHLY") {{ $t("ui.monthly") }}
                .form-group.col-md-12.col-lg-6.col-xl-3.col-12.mb-1
                  b-input-group(size="sm")
                    b-input-group-text(slot="prepend")
                      span {{ $t('ui.method') }}
                    b-form-select(v-model="payout_method" @change="getListSummary(true)" size="sm")
                      option(value="") {{ $t('ui.all') }}
                      option(value="INBOX") {{ $t('ui.inbox') }}
                      option(value="CREDIT") {{ $t("ui.credit") }}
                .form-group.col-md-12.col-lg-12.col-xl-12.col-12.mb-1
                  DateRangePicker(:value="dateRange" @update="getData")
                .form-group.col-12.mb-1
                  SubmitButton(
                    icon="fa fa-search"
                    :loading="loading"
                    :text="$t('ui.search')"
                    type="button"
                    @click="getListSummary(true)"
                    variant="primary"
                    size="sm"
                  ).mr-2
                  jsonToExcel(v-if="rescueSummary.length > 0" mode="RescueFundSummary" tbl="tblSummary" :date="dateRange" btnTxt="export_one" type="0" :loading2="loading2").mr-2
                  jsonToExcelFull(v-if="rescueSummaryFull.length > 0 && $helpers.showExportAll(dateRange) == true" mode="RescueFundSummary" tbl="tblSummaryFull" :date="dateRange" btnTxt="export_all" type="0" :loading2="loading2")
                  rescueFundSummaryExport(v-if="rescueSummary.length > 0" :tbl="rescueSummary" tblId="tblSummary" :totalTbl="grandTotalListSummary")
                  rescueFundSummaryExportFull(v-if="rescueSummaryFull.length > 0 && $helpers.showExportAll(dateRange) == true" :tbl="rescueSummaryFull" tblId="tblSummaryFull" :totalTbl="grandTotalListSummaryFull")
            .card-body
              .row
                .col-10.mb-1
                  b-pagination.float-left(
                    size="sm"
                    hide-ellipsis
                    :total-rows="totalRow"
                    :per-page="getPageSize"
                    v-model="currentPage"
                    @input="changedPage($event)")
                .col-2.mb-1
                  b-input-group(:prepend="$t('ui.page_size')" size="sm")
                    b-form-select(:options="$store.getters.pageSizeOptions" :value="getPageSize" @input="changedPageSize" size="sm")
                .col-12
                  .clusterize-scroll.table-responsive
                    table.table.table-sm.table-bordered.table-striped.table-hover.table-align-middle#tblList
                      thead.thead-light
                        tr
                          th.text-center(width="5%")
                            span #
                          th(width="35%" @click="sortOrder('operator_id')")
                            span(:title="$t('ui.operator_id')") {{ $t('ui.operator_id') }}
                            .float-right
                              i(:class="changeSortKey('operator_id')")
                          th.text-right(width="20%" @click="sortOrder('winlose')")
                            span(:title="$t('ui.winlose')") {{ $t('ui.winlose') }}
                            .float-right
                              i(:class="changeSortKey('winlose')")
                          th.text-right(width="20%" @click="sortOrder('actual_amount')")
                            span(:title="$t('ui.actual_amount')") {{ $t('ui.actual_amount') }}
                            .float-right
                              i(:class="changeSortKey('actual_amount')")
                          th.text-right(width="20%" @click="sortOrder('rounded_amount')")
                            span(:title="$t('ui.rounded_amount')") {{ $t('ui.rounded_amount') }}
                            .float-right
                              i(:class="changeSortKey('rounded_amount')")
                      tbody.clusterize-content
                        tr(v-if="rescueSummary.length == 0")
                          td(:colspan="5").text-center
                            span {{ $t('message.no_data_available') }}
                        tr(v-for="(item, index) in rescueSummary")
                          td.text-center
                            span(:title="((currentPage - 1) * getPageSize + index + 1)") {{ ((currentPage - 1) * getPageSize + index + 1) }}
                          td
                            span(:title="item.operator_id") 
                              b-link(href="javascript:void(0);" @click="drillIn(item.operator_id)") {{ item.operator_id }}
                          td.text-right
                            span.font-weight-bold(:title="$n(item.winlose, 'currency')" :class="$helpers.fontClassName(item.winlose)") {{ $n(item.winlose, 'currency') }}
                          td.text-right
                            span.font-weight-bold(:title="$n(item.actual_amount, 'currency')" :class="$helpers.fontClassName(item.actual_amount)") {{ $n(item.actual_amount, 'currency') }}
                          td.text-right
                            span.font-weight-bold(:title="$n(item.rounded_amount, 'currency')" :class="$helpers.fontClassName(item.rounded_amount)") {{ $n(item.rounded_amount, 'currency') }}
                          tr(v-if="showTotal")
                            td.text-right(colspan="2")
                              span.d-block {{ $t("ui.sub_total") }}
                              span {{ $t("ui.grand_total") }}
                            td.text-right
                              span.font-weight-bold.d-block(:class="$helpers.fontClassName(subTotalWinlose)" :title="$n(subTotalWinlose, 'currency')") {{ $n(subTotalWinlose, 'currency') }}
                              span.font-weight-bold(:class="$helpers.fontClassName(grandTotalWinlose)" :title="$n(grandTotalWinlose, 'currency')") {{ $n(grandTotalWinlose, 'currency') }}
                            td.text-right
                              span.font-weight-bold.d-block(:class="$helpers.fontClassName(subTotalActualAmount)" :title="$n(subTotalActualAmount, 'currency')") {{ $n(subTotalActualAmount, 'currency') }}
                              span.font-weight-bold(:class="$helpers.fontClassName(grandTotalActualAmount)" :title="$n(grandTotalActualAmount, 'currency')") {{ $n(grandTotalActualAmount, 'currency') }}
                            td.text-right
                              span.font-weight-bold.d-block(:class="$helpers.fontClassName(subTotalRoundedAmount)" :title="$n(subTotalRoundedAmount, 'currency')") {{ $n(subTotalRoundedAmount, 'currency') }}
                              span.font-weight-bold(:class="$helpers.fontClassName(grandTotalRoundedAmount)" :title="$n(grandTotalRoundedAmount, 'currency')") {{ $n(grandTotalRoundedAmount, 'currency') }}
          template(v-else)
            template(v-if="isDetail")
              .card-header
                .row.w-100              
                  .form-group.col-md-12.col-lg-6.col-xl-3.col-12.mb-1
                    b-input-group(size="sm")
                      b-input-group-text(slot="prepend")
                        span {{ $t('ui.cycle') }}
                      b-form-select(v-model="rescue_cycle" @change="getRecueFundSummaryDaily(true)" size="sm")
                        option(value="") {{ $t('ui.all') }}
                        option(value="DAILY") {{ $t('ui.daily') }}
                        option(value="WEEKLY") {{ $t("ui.weekly") }}
                        option(value="MONTHLY") {{ $t("ui.monthly") }}
                  .form-group.col-md-12.col-lg-6.col-xl-3.col-12.mb-1
                    b-input-group(size="sm")
                      b-input-group-text(slot="prepend")
                        span {{ $t('ui.method') }}
                      b-form-select(v-model="payout_method" @change="getRecueFundSummaryDaily(true)" size="sm")
                        option(value="") {{ $t('ui.all') }}
                        option(value="INBOX") {{ $t('ui.inbox') }}
                        option(value="CREDIT") {{ $t("ui.credit") }}
                  .form-group.col-md-12.col-lg-12.col-xl-6.col-12.mb-1
                    DateRangePicker(:value="dateRange1" @update="getData1")
                  .form-group.col-12.mb-1
                    SubmitButton(
                      icon="fa fa-search"
                      :loading="loading"
                      :text="$t('ui.search')"
                      type="button"
                      @click="getRecueFundSummaryDaily(true)"
                      variant="primary"
                      size="sm"
                    ).mr-2
                    jsonToExcel(v-if="rescueSummaryDaily.length > 0" mode="RescueFundSummaryDaily" tbl="tblSummaryDetail" :date="dateRange" btnTxt="export_one" type="0" :loading2="loading2").mr-2
                    rescueFundSummaryDailyExport(v-if="rescueSummaryDaily.length > 0" :tbl="rescueSummaryDaily" tblId="tblSummaryDetail" :totalTbl="grandTotalListSummaryDaily")
              .card-body
                .row
                  .col-12.mb-1
                    h2.section-title.mt-0 {{ selectedOperatorID }}
                  .col-10.mb-1
                    b-pagination.float-left(
                      size="sm"
                      hide-ellipsis
                      :total-rows="totalRow1"
                      :per-page="getPageSize"
                      v-model="currentPage1"
                      @input="changedPage1($event)")
                  .col-2.mb-1
                    b-input-group(:prepend="$t('ui.page_size')" size="sm")
                      b-form-select(:options="$store.getters.pageSizeOptions" :value="getPageSize" @input="changedPageSize1" size="sm")
                  .col-12
                    .clusterize-scroll.table-responsive
                      table.table.table-sm.table-bordered.table-striped.table-hover.table-align-middle#tblList
                        thead.thead-light
                          tr
                            th.text-center(width="5%")
                              span #
                            th(width="35%" @click="sortOrder1('working_date')")
                              span(:title="$t('ui.working_date')") {{ $t('ui.working_date') }}
                              .float-right
                                i(:class="changeSortKey1('working_date')")
                            th.text-right(width="20%" @click="sortOrder1('winlose')")
                              span(:title="$t('ui.winlose')") {{ $t('ui.winlose') }}
                              .float-right
                                i(:class="changeSortKey1('winlose')")
                            th.text-right(width="20%" @click="sortOrder1('actual_amount')")
                              span(:title="$t('ui.actual_amount')") {{ $t('ui.actual_amount') }}
                              .float-right
                                i(:class="changeSortKey1('actual_amount')")
                            th.text-right(width="20%" @click="sortOrder1('rounded_amount')")
                              span(:title="$t('ui.rounded_amount')") {{ $t('ui.rounded_amount') }}
                              .float-right
                                i(:class="changeSortKey1('rounded_amount')")
                        tbody.clusterize-content
                          tr(v-if="rescueSummaryDaily.length == 0")
                            td(:colspan="5").text-center
                              span {{ $t('message.no_data_available') }}
                          tr(v-for="(item, index) in rescueSummaryDaily")
                            td.text-center
                              span(:title="((currentPage1 - 1) * getPageSize + index + 1)") {{ ((currentPage1 - 1) * getPageSize + index + 1) }}
                            td
                              span(:title="$moment(item.working_date).format('YYYY-MM-DD')") 
                                b-link(href="javascript:void(0);" @click="drillIn1(item.working_date)") {{ $moment(item.working_date).format('YYYY-MM-DD') }}
                            td.text-right
                              span.font-weight-bold(:title="$n(item.winlose, 'currency')" :class="$helpers.fontClassName(item.winlose)") {{ $n(item.winlose, 'currency') }}
                            td.text-right
                              span.font-weight-bold(:title="$n(item.actual_amount, 'currency')" :class="$helpers.fontClassName(item.actual_amount)") {{ $n(item.actual_amount, 'currency') }}
                            td.text-right
                              span.font-weight-bold(:title="$n(item.rounded_amount, 'currency')" :class="$helpers.fontClassName(item.rounded_amount)") {{ $n(item.rounded_amount, 'currency') }}
                            tr(v-if="showTotal1")
                              td.text-right(colspan="2")
                                span.d-block {{ $t("ui.sub_total") }}
                                span {{ $t("ui.grand_total") }}
                              td.text-right
                                span.font-weight-bold.d-block(:class="$helpers.fontClassName(subTotalWinlose1)" :title="$n(subTotalWinlose1, 'currency')") {{ $n(subTotalWinlose1, 'currency') }}
                                span.font-weight-bold(:class="$helpers.fontClassName(grandTotalWinlose1)" :title="$n(grandTotalWinlose1, 'currency')") {{ $n(grandTotalWinlose1, 'currency') }}
                              td.text-right
                                span.font-weight-bold.d-block(:class="$helpers.fontClassName(subTotalActualAmount1)" :title="$n(subTotalActualAmount1, 'currency')") {{ $n(subTotalActualAmount1, 'currency') }}
                                span.font-weight-bold(:class="$helpers.fontClassName(grandTotalActualAmount1)" :title="$n(grandTotalActualAmount1, 'currency')") {{ $n(grandTotalActualAmount1, 'currency') }}
                              td.text-right
                                span.font-weight-bold.d-block(:class="$helpers.fontClassName(subTotalRoundedAmount1)" :title="$n(subTotalRoundedAmount1, 'currency')") {{ $n(subTotalRoundedAmount1, 'currency') }}
                                span.font-weight-bold(:class="$helpers.fontClassName(grandTotalRoundedAmount1)" :title="$n(grandTotalRoundedAmount1, 'currency')") {{ $n(grandTotalRoundedAmount1, 'currency') }}
            template(v-if="isMember")
              .card-header
                .row.w-100
                  //- .form-group.col-md-12.col-lg-12.col-xl-6.col-12.mb-1
                  //-   DateRangePicker(:value="dateRange2" @update="getData2")
                  .form-group.col-12.mb-1
                    SubmitButton(
                      icon="fa fa-sync"
                      :loading="loading"
                      :text="$t('ui.refresh')"
                      type="button"
                      @click="getRescueMember(true)"
                      variant="primary"
                      size="sm"
                    ).mr-2
                    jsonToExcel(v-if="rescueMember.length > 0" mode="RescueFundMember" tbl="tblMember" :date="dateRange" btnTxt="export_one" type="0" :loading2="loading2").mr-2
                    rescueFundMemberExport(v-if="rescueMember.length > 0" :tbl="rescueMember" tblId="tblMember")
              .card-body
                .row
                  .col-12.mb-1
                    h2.section-title.mt-0 {{ selectedOperatorID }}
                  .col-10.mb-1
                    b-pagination.float-left(
                      size="sm"
                      hide-ellipsis
                      :total-rows="totalRow2"
                      :per-page="getPageSize"
                      v-model="currentPage2"
                      @input="changedPage2($event)")
                  .col-2.mb-1
                    b-input-group(:prepend="$t('ui.page_size')" size="sm")
                      b-form-select(:options="$store.getters.pageSizeOptions" :value="getPageSize" @input="changedPageSize2" size="sm")
                  .col-12
                    .clusterize-scroll.table-responsive
                      table.table.table-sm.table-bordered.table-striped.table-hover.table-align-middle#tblList
                        thead.thead-light
                          tr
                            th.text-center(width="3%")
                              span #
                            th.text-left(width="7%" @click="sortOrder2('account_id')")
                              span(:title="$t('ui.account_id')") {{ $t('ui.account_id') }}
                              .float-right
                                i(:class="changeSortKey2('account_id')")
                            th.text-left(width="7%")
                              span(:title="$t('ui.rescue_id')") {{ $t('ui.rescue_id') }}
                            th.text-left(width="7%" @click="sortOrder2('start_date')")
                              span(:title="$t('ui.cycle')") {{ $t('ui.cycle') }}
                              .float-right
                                i(:class="changeSortKey2('start_date')")
                            th.text-right(width="7%" @click="sortOrder2('min_lose')")
                              span(:title="$t('ui.min_lose')") {{ $t('ui.min_lose') }}
                              .float-right
                                i(:class="changeSortKey2('min_lose')")
                            th.text-right(width="8%" @click="sortOrder2('total_winlose')")
                              span(:title="$t('ui.total_winlose')") {{ $t('ui.total_winlose') }}
                              .float-right
                                i(:class="changeSortKey2('total_winlose')")
                            th.text-right(width="5%" @click="sortOrder2('rescue_rate')")
                              span(:title="$t('ui.rate')") {{ $t('ui.rate') }}
                              .float-right
                                i(:class="changeSortKey2('rescue_rate')")
                            th.text-right(width="7%" @click="sortOrder2('max_payout')")
                              span(:title="$t('ui.max_payout')") {{ $t('ui.max_payout') }}
                              .float-right
                                i(:class="changeSortKey2('max_payout')")
                            th.text-right(width="7%" @click="sortOrder2('actual_amount')")
                              span(:title="$t('ui.amount')") {{ $t('ui.amount') }}
                              .float-right
                                i(:class="changeSortKey2('actual_amount')")                            
                            th(width="8%" @click="sortOrder2('payout_method')")
                              span(:title="$t('ui.payout_method')") {{ $t('ui.payout_method') }}
                              .float-right
                                i(:class="changeSortKey2('payout_method')")
                            th.text-center(width="7%" @click="sortOrder2('target_group')")
                              span(:title="$t('ui.target_group')") {{ $t('ui.target_group') }}
                              .float-right
                                i(:class="changeSortKey2('target_group')")
                            th.text-right(width="5%" @click="sortOrder2('member_vip_id')")
                              span(:title="$t('ui.member_vip_id')") {{ $t('ui.vip_id') }}
                              .float-right
                                i(:class="changeSortKey2('member_vip_id')")
                            th.text-right(width="5%")
                              span(:title="$t('ui.vip_list')") {{ $t('ui.vip_list') }}
                            th.text-center(width="5%" @click="sortOrder2('action_status')")
                              span(:title="$t('ui.status')") {{ $t('ui.status') }}
                              .float-right
                                i(:class="changeSortKey2('action_status')")
                            th.text-right(width="7%" @click="sortOrder2('action_date')")
                              span(:title="$t('ui.date')") {{ $t('ui.date') }}
                              .float-right
                                i(:class="changeSortKey2('action_date')")
                        tbody.clusterize-content
                          tr(v-if="rescueMember.length == 0")
                            td(:colspan="13").text-center
                              span {{ $t('message.no_data_available') }}
                          template(v-for="(item, index) in rescueMember")
                            tr
                              td.text-center
                                span(:title="((currentPage2 - 1) * getPageSize + index + 1)") {{ ((currentPage2 - 1) * getPageSize + index + 1) }}
                              td.text-left
                                span(:title="item.account_id") {{ item.account_id }}
                              td.text-left
                                span.d-block.small(:title="item.rescue_id") {{ item.rescue_id }}
                                span(:title="item.rescue_name") {{ item.rescue_name }}
                              td.text-left
                                span.d-block(:title="item.rescue_cycle") {{ item.rescue_cycle }}
                                span.d-block(:title="$moment(item.start_date).format('YYYY-MM-DD')") {{ $moment(item.start_date).format('YYYY-MM-DD') }}
                                span(:title="$moment(item.end_date).format('YYYY-MM-DD')") {{ $moment(item.end_date).format('YYYY-MM-DD') }}
                              td.text-right
                                span.font-weight-bold(:title="$n(item.min_lose, 'currency')" :class="$helpers.fontClassName(item.min_lose)") {{ $n(item.min_lose, 'currency') }}
                              td.text-right
                                span(:title="$n(item.total_winlose, 'currency')")
                                  b-link.clickable.font-weight-bold.text-decoration-none(href="javascript:void(0);" :class="$helpers.fontClassName(item.total_winlose)" @click="onGetProvider(item)") {{ $n(item.total_winlose, 'currency') }}
                              td.text-right
                                span.font-weight-bold(:title="$n(item.rescue_rate, 'currency')" :class="$helpers.fontClassName(item.rescue_rate)") {{ $n(item.rescue_rate, 'currency') }}
                              td.text-right
                                span.font-weight-bold(:title="$n(item.max_payout, 'currency')" :class="$helpers.fontClassName(item.max_payout)") {{ $n(item.max_payout, 'currency') }}
                              td.text-right
                                span.font-weight-bold.d-block(:title="$n(item.actual_amount, 'currency')" :class="$helpers.fontClassName(item.actual_amount)") {{ $n(item.actual_amount, 'currency') }}
                                i.fa.ml-1.fa-arrow-down.d-block(v-if="item.actual_amount && item.rounded_amount")
                                span.font-weight-bold(:title="$n(item.rounded_amount, 'currency')" :class="$helpers.fontClassName(item.rounded_amount)") {{ $n(item.rounded_amount, 'currency') }}
                              td
                                span.d-block(:title="item.payout_method") {{ item.payout_method }}
                                span(:title="item.inbox_id") {{ item.inbox_id }}
                              td.text-center
                                span(:title="item.target_group") {{ item.target_group }}
                              td.text-left
                                span(:title="item.member_vip_id") {{ item.member_vip_id }}
                              td.text-left
                                span(:title="item.vip_list") {{ item.vip_list }}
                              td.text-center
                                span.font-weight-bold.badge.badge-info(v-if="item.action_status.trim().toUpperCase() == 'SKIP'") {{ item.action_status.trim().toUpperCase() }}
                                span.font-weight-bold.badge.badge-success(v-if="item.action_status.trim().toUpperCase() == 'SUCCESS'") {{ item.action_status.trim().toUpperCase() }}
                              td.text-right
                                span(:title="$moment(item.action_date).format('YYYY-MM-DD HH:mm:ss')") {{ $moment(item.action_date).format('YYYY-MM-DD HH:mm:ss') }}                              
                            tr.text-center(v-if="isShowDetail == true && currId == item.id")
                              td(colspan="15")
                                table.table.table-sm.table-bordered.table-hover(style="width: 50%;").mb-2.m-auto
                                  //- thead.thead-dark
                                  //-   tr
                                  //-     th.text-center(width="5%")
                                  //-       span #
                                  //-     th.text-left(width="45%")
                                  //-       span {{ $t("ui.provider_code") }}
                                  //-     th.text-right(width="50%")
                                  //-       span {{ $t("ui.winlose") }}
                                  tbody.clusterize-content
                                    tr.table-info
                                      th.text-center(width="5%")
                                        span #
                                      th.text-left(width="45%")
                                        span {{ $t("ui.provider_code") }}
                                      th.text-right(width="50%")
                                        span {{ $t("ui.winlose") }}
                                    tr(v-if="rescueProvider.length == 0")
                                      td(:colspan="12").text-center
                                        span {{ $t('message.no_data_available') }}
                                    template(v-for="(item1, index1) in rescueProvider")
                                      tr
                                        td {{ index1 + 1 }}
                                        td
                                          span(:title="item1.provider_code") {{ item1.provider_code }}
                                        td.text-right
                                          span.font-weight-bold(:title="$n(item1.winlose, 'currency')" :class="$helpers.fontClassName(item1.winlose)") {{ $n(item1.winlose, 'currency') }}


</template>

<script>
import config from "@/config";
import errorTags from "@/errorTags";
import SubmitButton from "@/library/SubmitButton.vue";
import DebounceInput from "@/library/DebounceInput";
import DateRangePicker from "@/library/DateRangePicker.vue";
import 'vue2-daterange-picker/dist/vue2-daterange-picker.css';
import jsonToExcel from "@/library/jsonToExcelFull.vue";
import jsonToExcelFull from "@/library/jsonToExcelFull.vue";
import rescueFundSummaryExport from "@/components/report/rescueFundSummaryExportFull.vue";
import rescueFundSummaryExportFull from "@/components/report/rescueFundSummaryExportFull.vue";
import rescueFundSummaryDailyExport from "@/components/report/rescueFundSummaryDailyExportFull.vue";
import rescueFundMemberExport from "@/components/report/rescueFundMemberExportFull.vue";

export default {
  components: {
    SubmitButton,
    DebounceInput,
    DateRangePicker,
    jsonToExcel,
    jsonToExcelFull,
    rescueFundSummaryExport,
    rescueFundSummaryExportFull,
    rescueFundSummaryDailyExport,
    rescueFundMemberExport
  },
  data: () => ({
    loading: false,
    loading2: false,
    feedback: {
      success: false,
      status: errorTags.request.failed
    },
    dateRange: {
      startDate: null,
      endDate: null,
    },
    dateRange1: {
      startDate: null,
      endDate: null,
    },
    dateRange2: {
      startDate: null,
      endDate: null,
    },
    searchID: "",
    rescue_cycle: "",
    payout_method: "",
    currId: null,
    isDetail: false,
    isMember: false,
    selectedOperatorID: "",
    rescueSummary: [],
    rescueSummaryFull: [],
    rescueSummaryDaily: [],
    rescueMember: [],
    rescueProvider: [],
    currentPage: 1,
    totalRow: 0,
    sortKey: "account_id",
    sortType: "asc",
    currentPage1: 1,
    totalRow1: 0,
    sortKey1: "working_date",
    sortType1: "asc",
    currentPage2: 1,
    totalRow2: 0,
    sortKey2: "working_date",
    sortType2: "asc",
    isShowDetail: false,
    showTotal: false,
    showTotal1: false,
    showTotal2: false,
    subTotalWinlose: 0,
    grandTotalWinlose: 0,
    subTotalActualAmount: 0,
    grandTotalActualAmount: 0,
    subTotalRoundedAmount: 0,
    grandTotalRoundedAmount: 0,
    subTotalWinlose1: 0,
    grandTotalWinlose1: 0,
    subTotalActualAmount1: 0,
    grandTotalActualAmount1: 0,
    subTotalRoundedAmount1: 0,
    grandTotalRoundedAmount1: 0,
    grandTotalListSummary: [],
    grandTotalListSummaryFull: [],
    grandTotalListSummaryDaily: [],
  }),
  computed: {
    getPageSize() {
      return this.$store.getters.pageSize;
    },
    isOperator() {
      return [2].includes(this.$store.getters.accountType);
    },
    accountID() {
      return this.$store.getters.accountId;
    },
  },
  mounted: function() {
    this.dateRange.startDate = this.$moment(new Date).format('YYYY-MM-DD');
    this.dateRange.endDate = this.$moment(new Date).format('YYYY-MM-DD');
    if(this.$store.getters.sessionToken) {
      if(this.isOperator) {
        this.isDetail = true
        this.$nextTick(() => {
          this.dateRange1.startDate = this.$moment(new Date).format('YYYY-MM-DD');
          this.dateRange1.endDate = this.$moment(new Date).format('YYYY-MM-DD');
          this.selectedOperatorID = this.accountID;
          this.getRecueFundSummaryDaily(true);
        });        
      } else {
        // this.dateRange.startDate = this.$moment(new Date).format('YYYY-MM-DD');
        // this.dateRange.endDate = this.$moment(new Date).format('YYYY-MM-DD');
        if (this.$store.getters.reportStatement.operator_id != null)
          this.searchID = this.$store.getters.reportStatement.operator_id;

        if (this.$store.getters.reportStatement.start_date && this.$store.getters.reportStatement.end_date) {
          this.dateRange.startDate = this.$store.getters.reportStatement.start_date;
          this.dateRange.endDate = this.$store.getters.reportStatement.end_date;
        }
        this.getListSummary(true);
      }
    }
  },
  methods: {
    onGetProvider(item) {
      // this.selectedPayout = e;
      // this.$refs.getrescuefundprovider.$refs.getRescueFundProvider.show();
      if (this.isShowDetail == true) {
        if (this.currId == item.id) {
          this.isShowDetail = false;
          this.currId = null;
        } else {
          this.isShowDetail = true;
          this.currId = item.id;
          this.getRescueProvider(item.id)
        }
      } else {
        this.isShowDetail = true;
        this.currId = item.id;
        this.getRescueProvider(item.id)
      }
    },
    redirect() {
      this.isDetail = false;
      this.isMember = false;
      this.getListSummary(true);
    },
    redirect1() {
      this.isDetail = true;
      this.isMember = false;
      this.getRecueFundSummaryDaily(true);
    },
    // onOffDetail(item) {
    //   if (this.isShowDetail == true) {
    //     if (this.currId == item.id) {
    //       this.isShowDetail = false;
    //       this.currId = null;
    //     } else {
    //       this.isShowDetail = true;
    //       this.currId = item.id;
    //       this.getRescueProvider(item.id)
    //     }
    //   } else {
    //     this.isShowDetail = true;
    //     this.currId = item.id;
    //     this.getRescueProvider(item.id)
    //   }
    // },
    sortOrder(key) {
      if (this.sortKey == key)
        this.sortType = this.sortType == 'asc' ? 'desc' : 'asc';
      else {
        this.sortKey = key;
        this.sortType = 'asc';
      }
      this.getRecueFundSummary(true);

    },
    sortOrder1(key) {
      if (this.sortKey1 == key)
        this.sortType1 = this.sortType1 == 'asc' ? 'desc' : 'asc';
      else {
        this.sortKey1 = key;
        this.sortType1 = 'asc';
      }
      this.getRecueFundSummaryDaily(true);

    },
    sortOrder2(key) {
      if (this.sortKey2 == key)
        this.sortType2 = this.sortType2 == 'asc' ? 'desc' : 'asc';
      else {
        this.sortKey2 = key;
        this.sortType2 = 'asc';
      }
      this.getRescueMember(true);

    },
    changeSortKey(key) {
      if (this.sortKey != key)
        return 'fas fa-sort';
      else if (this.sortKey == key && this.sortType == 'asc')
        return 'fa fa-sort-up';
      else if (this.sortKey == key && this.sortType == 'desc')
        return 'fa fa-sort-down';
    },
    changeSortKey1(key) {
      if (this.sortKey != key)
        return 'fas fa-sort';
      else if (this.sortKey == key && this.sortType == 'asc')
        return 'fa fa-sort-up';
      else if (this.sortKey == key && this.sortType == 'desc')
        return 'fa fa-sort-down';
    },
    changeSortKey2(key) {
      if (this.sortKey != key)
        return 'fas fa-sort';
      else if (this.sortKey == key && this.sortType == 'asc')
        return 'fa fa-sort-up';
      else if (this.sortKey == key && this.sortType == 'desc')
        return 'fa fa-sort-down';
    },
    checkDateRange() {
      if (this.$moment(this.dateRange.endDate).diff(this.$moment(this.dateRange.startDate), 'days') > 31)
        return false;
      else
        return true;
    },
    getData(currentValue) {
      this.dateRange.startDate = this.$moment(currentValue.startDate).format('YYYY-MM-DD');
      this.dateRange.endDate = this.$moment(currentValue.endDate).format('YYYY-MM-DD');
      this.getListSummary(true);
    },
    getData1(currentValue) {
      this.dateRange1.startDate = this.$moment(currentValue.startDate).format('YYYY-MM-DD');
      this.dateRange1.endDate = this.$moment(currentValue.endDate).format('YYYY-MM-DD');
      this.getRecueFundSummaryDaily(true);
    },
    getData2(currentValue) {
      this.dateRange2.startDate = this.$moment(currentValue.startDate).format('YYYY-MM-DD');
      this.dateRange2.endDate = this.$moment(currentValue.endDate).format('YYYY-MM-DD');
      // this.getRescueMember(true);
    },
    getListSummary(isSearch) {
      if (this.checkDateRange()) {
        this.getRecueFundSummary(isSearch);
        if (this.$helpers.showExportAll(this.dateRange) == true) {
          this.getRecueFundSummaryFull(isSearch);
        }
      } else {
        this.clearRecueFundSummary();
        this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error.dateRangeAllowOneMonth"), "error");
      }
    },
    submit() {
      // if(this.child) {
      //   this.getPayoutListWorkingDate(this.dateRange2.startDate)
      // } else {
      //   this.getRecueFundSummary(true)
      // }
    },
    drillIn(id) {
      this.isDetail = true
      this.dateRange1.startDate = this.dateRange.startDate;
      this.dateRange1.endDate = this.dateRange.endDate;
      this.selectedOperatorID = id;

      this.getRecueFundSummaryDaily();
    },
    drillIn1(date) {
      this.isDetail = false
      this.isMember = true
      this.dateRange2.startDate = date;
      this.dateRange2.endDate = date;

      this.getRescueMember();
    },
    setReportStatementParam: function() {
      var json = {
        operator_id: this.searchID,
        start_date: this.dateRange.startDate,
        end_date: this.dateRange.endDate
      };
      this.$store.dispatch("user/setReportStatementParam", json);
    },
    getRecueFundSummary: function(isSearch) {
      this.child = false
      if (this.checkDateRange()) {
        this.setReportStatementParam();
        let url = config.rescueFundPayoutSummaryUrl();

        if (isSearch) this.currentPage = 1;

        var json = {
          action_by: this.$store.getters.loginId,
          auth_token: this.$store.getters.sessionToken,
          start_date: this.dateRange.startDate,
          end_date: this.dateRange.endDate,
          operator_id: this.searchID,
          rescue_cycle: this.rescue_cycle == "" ? null : this.rescue_cycle,
          payout_method: this.payout_method == "" ? null : this.payout_method,
          sort_key: this.sortKey,
          sort_type: this.sortType,
          page_number: this.currentPage,
          page_size: this.getPageSize
        };

        this.loading = true;
        this.$http.post(url, json).then(
          function(response) {
            this.clearRecueFundSummary()
            this.loading = false;
            // Success
            try {
              if (response) {
                this.feedback.success = typeof response.data.status == "string" ? response.data.status == "1" : response.data.status == 1;

                this.feedback.status = response.data.statusdesc;
                if (this.feedback.success == true) {
                  if(response.data.ds.list.length > 0) {
                    this.showTotal = true
                    response.data.ds.list.forEach(value => {
                      this.subTotalWinlose = parseFloat(this.subTotalWinlose) + parseFloat(value["winlose"]);
                      this.subTotalActualAmount = parseFloat(this.subTotalActualAmount) + parseFloat(value["actual_amount"]);
                      this.subTotalRoundedAmount = parseFloat(this.subTotalRoundedAmount) + parseFloat(value["rounded_amount"]);
                    });

                    if(response.data.ds.grand_total.length > 0) {
                      this.grandTotalWinlose = response.data.ds.grand_total[0]["winlose"];
                      this.grandTotalActualAmount = response.data.ds.grand_total[0]["actual_amount"];
                      this.grandTotalRoundedAmount = response.data.ds.grand_total[0]["rounded_amount"];
                    }

                    this.grandTotalListSummary = response.data.ds.grand_total;
                    this.rescueSummary = response.data.ds.list;
                    this.totalRow = this.rescueSummary.length > 0 ? this.rescueSummary[0].totalrows : 0;
                  } else {
                    this.clearRecueFundSummary()
                  }
                } else {
                  this.clearRecueFundSummary()
                  if (!this.$helpers.handleFeedback(this.feedback.status)) this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
                }
              }
            } catch (error) {
              this.feedback.success = false;
              this.feedback.status = errorTags.request.failed;
              this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
            }
          },
          function(response) {
            this.loading = false;
            // Error
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
            this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
          }
        );
      }
      else {
        this.clearRecueFundSummary();
        this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error.dateRangeAllowOneMonth"), "error");
      }
    },
    getRecueFundSummaryFull: function(isSearch) {
      if (this.checkDateRange()) {
        let url = config.rescueFundPayoutSummaryUrl();

        if (isSearch) this.currentPage = 1;

        var json = {
          action_by: this.$store.getters.loginId,
          auth_token: this.$store.getters.sessionToken,
          start_date: this.dateRange.startDate,
          end_date: this.dateRange.endDate,
          operator_id: this.searchID,
          rescue_cycle: this.rescue_cycle == "" ? null : this.rescue_cycle,
          payout_method: this.payout_method == "" ? null : this.payout_method,
          sort_key: this.sortKey,
          sort_type: this.sortType,
          page_number: this.currentPage,
          page_size: -1
        };

        this.loading2 = true;
        this.$http.post(url, json).then(
          function(response) {
            this.loading2 = false;
            // Success
            try {
              if (response) {
                this.feedback.success = typeof response.data.status == "string" ? response.data.status == "1" : response.data.status == 1;

                this.feedback.status = response.data.statusdesc;
                if (this.feedback.success == true) {
                  this.grandTotalListSummaryFull = response.data.ds.grand_total;
                  this.rescueSummaryFull = response.data.ds.list;
                }
              }
            } catch (error) {
              this.feedback.success = false;
              this.feedback.status = errorTags.request.failed;
              this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
            }
          },
          function(response) {
            this.loading2 = false;
            // Error
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
            this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
          }
        );
      }
    },
    getRecueFundSummaryDaily: function(isSearch) {
      if (this.checkDateRange()) {
        let url = config.rescueFundPayoutSummaryDailyUrl();

        if (isSearch) this.currentPage = 1;

        var json = {
          action_by: this.$store.getters.loginId,
          auth_token: this.$store.getters.sessionToken,
          start_date: this.dateRange1.startDate,
          end_date: this.dateRange1.endDate,
          operator_id: this.selectedOperatorID,
          rescue_cycle: this.rescue_cycle == "" ? null : this.rescue_cycle,
          payout_method: this.payout_method == "" ? null : this.payout_method,
          sort_key: this.sortKey1,
          sort_type: this.sortType1,
          page_number: this.currentPage1,
          page_size: this.getPageSize
        };

        this.loading = true;
        this.$http.post(url, json).then(
          function(response) {
            this.clearRecueFundSummaryDaily()
            this.loading = false;
            // Success
            try {
              if (response) {
                this.feedback.success = typeof response.data.status == "string" ? response.data.status == "1" : response.data.status == 1;

                this.feedback.status = response.data.statusdesc;
                if (this.feedback.success == true) {
                  if(response.data.ds.list.length > 0) {
                    this.showTotal1 = true
                    response.data.ds.list.forEach(value => {
                      this.subTotalWinlose1 = parseFloat(this.subTotalWinlose1) + parseFloat(value["winlose"]);
                      this.subTotalActualAmount1 = parseFloat(this.subTotalActualAmount1) + parseFloat(value["actual_amount"]);
                      this.subTotalRoundedAmount1 = parseFloat(this.subTotalRoundedAmount1) + parseFloat(value["rounded_amount"]);
                    });

                    if(response.data.ds.grand_total.length > 0) {
                      this.grandTotalWinlose1 = response.data.ds.grand_total[0]["winlose"];
                      this.grandTotalActualAmount1 = response.data.ds.grand_total[0]["actual_amount"];
                      this.grandTotalRoundedAmount1 = response.data.ds.grand_total[0]["rounded_amount"];
                    }

                    this.grandTotalListSummaryDaily = response.data.ds.grand_total;
                    this.rescueSummaryDaily = response.data.ds.list;
                    this.totalRow1 = this.rescueSummaryDaily.length > 0 ? this.rescueSummaryDaily[0].totalrows : 0;
                  } else {
                    this.clearRecueFundSummaryDaily()
                  }
                } else {
                  this.clearRecueFundSummaryDaily()
                  if (!this.$helpers.handleFeedback(this.feedback.status)) this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
                }
              }
            } catch (error) {
              this.feedback.success = false;
              this.feedback.status = errorTags.request.failed;
              this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
            }
          },
          function(response) {
            this.loading = false;
            // Error
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
            this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
          }
        );
      }
      else {
        this.clearRecueFundSummaryDaily();
        this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error.dateRangeAllowOneMonth"), "error");
      }
    },
    getRescueMember: function() {
      let url = config.rescueFundPayoutListUrl();

      var json = {
        action_by: this.$store.getters.loginId,
        auth_token: this.$store.getters.sessionToken,
        operator_id: this.selectedOperatorID,
        // start_date: this.dateRange2.startDate,
        // end_date: this.dateRange2.endDate,
        working_date: this.dateRange2.startDate,
        rebate_type: this.rebate_type == "" ? null : this.rebate_type,
        sort_key: this.sortKey2,
        sort_type: this.sortType2,
        page_number: this.currentPage2,
        page_size: this.getPageSize
      };

      this.loading = true;
      this.$http.post(url, json).then(
        function(response) {
          this.clearRescueMember()
          this.loading = false;
          // Success
          try {
            if (response) {
              this.feedback.success = typeof response.data.status == "string" ? response.data.status == "1" : response.data.status == 1;

              this.feedback.status = response.data.statusdesc;
              if (this.feedback.success == true) {
                if(response.data.dt.length > 0) {
                  this.showTotal2 = true

                  this.rescueMember = response.data.dt;
                  this.totalRow2 = this.rescueMember.length > 0 ? this.rescueMember[0].totalrows : 0;
                } else {
                  this.clearRescueMember()
                }
              } else {
                this.clearRescueMember()
                if (!this.$helpers.handleFeedback(this.feedback.status)) this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
              }
            }
          } catch (error) {
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
            this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
          }
        },
        function(response) {
          this.loading = false;
          // Error
          this.feedback.success = false;
          this.feedback.status = errorTags.request.failed;
          this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
        }
      );
    },
    getRescueProvider(payout_id) {
      this.clearRescueProvider()
      let url = config.rescueFundPayoutProviderUrl();

      var json = {
        action_by: this.$store.getters.loginId,
        auth_token: this.$store.getters.sessionToken,
        payout_id: payout_id
      };

      this.loading = true;
      this.$http.post(url, json).then(
        function(response) {
          this.loading = false;
          // Success
          try {
            if (response) {
              this.feedback.success = typeof response.data.status == "string" ? response.data.status == "1" : response.data.status == 1;

              this.feedback.status = response.data.statusdesc;
              if (this.feedback.success == true) {
                if(response.data.dt.length > 0) {
                  this.rescueProvider = response.data.dt;
                } else {
                  this.clearRescueProvider()
                }
              } else {
                this.clearRescueProvider()
                if (!this.$helpers.handleFeedback(this.feedback.status)) this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
              }
            }
          } catch (error) {
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
            this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
          }
        },
        function(response) {
          this.loading = false;
          // Error
          this.feedback.success = false;
          this.feedback.status = errorTags.request.failed;
          this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
        }
      );
    },
    clearRecueFundSummary() {
      this.showTotal = false
      this.totalRow = 0
      this.rescueSummary = []
      this.subTotalWinlose = 0
      this.grandTotalWinlose = 0
      this.subTotalActualAmount = 0
      this.grandTotalActualAmount = 0
      this.subTotalRoundedAmount = 0
      this.grandTotalRoundedAmount = 0
    },
    clearRecueFundSummaryDaily() {
      this.showTotal1 = false
      this.totalRow1 = 0
      this.rescueSummaryDaily = []
      this.subTotalWinlose1 = 0
      this.grandTotalWinlose1 = 0
      this.subTotalActualAmount1 = 0
      this.grandTotalActualAmount1 = 0
      this.subTotalRoundedAmount1 = 0
      this.grandTotalRoundedAmount1 = 0
    },
    clearRescueMember() {
      this.totalRow2 = 0;
      this.rescueMember = []
    },
    clearRescueProvider() {
      this.rescueProvider = []
    },
    changedPageSize: function(pageSize) {
      this.$store.dispatch("layout/setPageSize", pageSize);
      this.currentPage = 1;
      this.getRecueFundSummary(true);
    },
    changedPage: function(pageNo) {
      this.currentPage = pageNo;
      this.getRecueFundSummary();
    },
    changedPageSize1: function(pageSize) {
      this.$store.dispatch("layout/setPageSize", pageSize);
      this.currentPage1 = 1;
      this.getRecueFundSummaryDaily(true);
    },
    changedPage1: function(pageNo) {
      this.currentPage1 = pageNo;
      this.getRecueFundSummaryDaily();
    },
    changedPageSize2: function(pageSize) {
      this.$store.dispatch("layout/setPageSize", pageSize);
      this.currentPage2 = 1;
      this.getRescueMember(true);
      // this.getRebateMember(true);
    },
    changedPage2: function(pageNo) {
      this.currentPage2 = pageNo;
      this.getRescueMember();
      // this.getRebateMember();
    },
    handleFailed: function(tag, status) {
      this.$helpers.showDialog(this.$t("ui.combine." + tag), this.$t("error." + status), "error");
    }
  }
};
</script>